export default "/static/webpack/media/warning.b1d3c548.png";